import { useHistory } from 'react-router'
import { NonIdealState } from '@stoplight/elements-core'
import { Button, Flex, Text } from '@stoplight/mosaic'

export default function NotFound() {
  const history = useHistory()

  return (
    <Flex justify="center" alignItems="center" w="full" h="full">
      <NonIdealState
        title="Oops! Seems there is nothing here"
        description={
          <Button appearance="minimal" onClick={() => history.replace('/')}>
            <Text fontSize="lg" fontWeight="semibold">
              Return Home
            </Text>
          </Button>
        }
      />
    </Flex>
  )
}
